import React from 'react';
import { Query, ApolloProvider } from 'react-apollo';
import gql from 'graphql-tag';
import { createHttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import ApolloClient from 'apollo-client';
import qs from 'qs';
import { Redirect } from 'react-router-dom';

import Loading from '../shared/Loading';
import Login from './MagicLoginSucess';

const httpLink = createHttpLink({
  uri: `${process.env.REACT_APP_API_URL}/graphql`,
});

const client = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
});

const MagicLogin = ({ location, loginSuccess }) => {
  const { token = '' } = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });
  return (
    <ApolloProvider client={client}>
      <Query
        query={gql`
          query magicToken($token: String!) {
            magicToken(token: $token) {
              email
              authenticationToken
              status
              firstName
              lastName
              uberProfileImage
              operatingCity
            }
          }
        `}
        variables={{ token }}>
        {({ loading, error, data }) => {
          if (loading) return <Loading size="4x" />;
          if (error) return <Redirect push to="/404" />;
          return data.magicToken !== null ? (
            <Login
              login={loginSuccess}
              email={data.magicToken.email}
              authenticationToken={data.magicToken.authenticationToken}
              status={data.magicToken.status}
              firstName={data.magicToken.firstName}
              lastName={data.magicToken.lastName}
              uberProfileImageUrl={data.magicToken.uberProfileImageUrl}
              operatingCity={data.magicToken.operatingCity}
              token={token}
            />
          ) : (
            <Redirect push to="/404" />
          );
        }}
      </Query>
    </ApolloProvider>
  );
};

export default MagicLogin;



// WEBPACK FOOTER //
// ./src/components/User/MagicLogin.js